// src/Components/ProjectListing/ProjectListing.tsx
import React from "react";
import { Link } from "react-router-dom";
import { projectSetups, PLACEHOLDER_IMAGE } from "../../config";
import BlackBg from "Components/BlackBg/BlackBg";
import Header from "Components/Headers/Header";
import Footer from "Components/Footer";
import styled from "styled-components";

interface ProjectsListingProps {
  categoryKey: keyof typeof projectSetups;
  baseUrl: string;
}

const ProjectsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ProjectSection = styled.section`
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  scroll-snap-align: start;
`;

const ProjectBackground = styled.div<{ image: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  transition: transform 0.5s ease, filter 0.5s ease;

  /*  &:hover {
    filter: brightness(70%);
    transform: scale(1.05);
  }*/
`;

const ProjectInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  //background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2rem;
  z-index: 10;

  h1 {
    font-family: Anybody, cursive;
    color: rgb(161, 166, 180);
    font-size: 1.563rem;
    font-weight: 200;
    text-shadow: rgba(0, 0, 0, 0.3) 3px 4px 1px;
  }
  }
  
  /*  h2 {
    font-size: 3rem;
    margin: 0 0 0.5rem;
    text-transform: lowercase;
  }

  p {
    font-size: 1.5rem;
    margin: 0;
    opacity: 0.8;
  }*/
`;

const ScrollContainer = styled.div`
  height: 100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ProjectLink = styled(Link)`
  text-decoration: none;
  color: white;
  display: block;
  width: 100%;
  height: 100%;
`;

const ProjectsListing = ({ categoryKey, baseUrl }: ProjectsListingProps) => {
  const category = projectSetups[categoryKey];

  if (!category || !category.projects || category.projects.length === 0) {
    return (
      <BlackBg>
        <div style={{ color: "white", padding: "2rem", textAlign: "center" }}>
          No projects available
        </div>
      </BlackBg>
    );
  }

  return (
    <BlackBg>
      {category.headerProps && (
        <Header
          type={category.headerProps.type}
          name={category.headerProps.name}
          dir={category.headerProps.dir}
          redir={category.headerProps.redir}
        />
      )}

      <ScrollContainer>
        <ProjectsContainer>
          {category.projects.map((project) => (
            <ProjectSection key={project.key}>
              <ProjectLink to={`/${baseUrl}/${project.key}`}>
                <ProjectBackground
                  image={project.thumbnail || PLACEHOLDER_IMAGE}
                />
                <ProjectInfo>
                  <h1>{project.name}</h1>
                  <h1>{project.dir}</h1>
                </ProjectInfo>
              </ProjectLink>
            </ProjectSection>
          ))}
        </ProjectsContainer>
      </ScrollContainer>

      <Footer />
    </BlackBg>
  );
};

export default ProjectsListing;
